import { css } from 'foundations-theming/utils';
import { createFocusStateSelector, createFocusVisibleStateSelector } from '../styles/styles';
/**
 * Edge 18 and Safari 11 do not support :focus-visible, so we need fallback to
 * :focus for those browsers to ensure some focus styles are applied.
 * https://caniuse.com/?search=%3Afocus-visible
 */
export function supportsFocusVisible() {
  return window.CSS && CSS.supports && CSS.supports('selector(:focus-visible)');
}
export const getFocusPseudoClass = () => {
  return supportsFocusVisible() ? createFocusVisibleStateSelector('&&:focus-visible') : createFocusStateSelector('&&:focus');
};
export const getFocusStyleObject = ({
  theme,
  addBorderRadius,
  increaseOutlineOffset,
  unwrapped,
  override,
  disableFocusStyles
}) => {
  const styles = Object.assign({
    borderColor: `${theme.color['fill-transparent-default']} !important`,
    outline: `${theme.borderWidth['200']} solid ${theme.color['border-info-default']} !important`,
    outlineOffset: `calc(${theme.borderWidth['200']} * -1)`,
    boxShadow: `inset 0 0 0 ${theme.borderWidth['200']} ${theme.color['border-core-on-fill-default']} !important`
  }, increaseOutlineOffset && {
    // Increase the outlineOffset from -2px to -1px
    outlineOffset: `calc(${theme.borderWidth['100']} * -1)`,
    // Adjust the box shadow to match the new outlineOffset
    boxShadow: `inset 0 0 0 ${theme.borderWidth['100']} ${theme.color['border-core-on-fill-default']} !important`
  }, addBorderRadius && {
    borderRadius: theme.borderRadius['100']
  });
  if (override) {
    return {
      borderColor: 'inherit !important',
      boxShadow: 'none !important',
      outline: 'none !important'
    };
  }
  if (disableFocusStyles) {
    return {
      [getFocusPseudoClass()]: {
        outline: 'none !important'
      }
    };
  }
  if (unwrapped) {
    return styles;
  }
  return {
    [getFocusPseudoClass()]: styles
  };
};
export const getFocusStyle = ({
  theme,
  addBorderRadius,
  increaseOutlineOffset,
  unwrapped,
  override
}) => css(getFocusStyleObject({
  theme,
  addBorderRadius,
  increaseOutlineOffset,
  unwrapped,
  override
}));